import React from 'react'
import { Link } from 'react-router-dom'
import { products } from '../data'
import { HomePath } from '../home-path'

export default function PopularSearch() {
  return (
    <section className="w-full h-fit py-12">
        <div className="mxw">
            {/* section heading */}
            <div className="w-full h-fit py-4 text-left">
                <p className="text-2xl md:text-3xl font-semibold">Popular Searches</p>
            </div>
            <div className="w-full pt-6">
                <ul className="space-y-2">
                    {products?.slice(3,7)?.map(product => (
                        <li key={product?.id} className="flex items-center space-x-2 text-sm md:text-md lg:text-lg border-b border-b-gray-100 rounded-md py-2">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 md:w-6 md:h-6 text-gray-300">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                            </svg>

                        </span>
                        <div>
                            <Link to={HomePath + `/product/${product?.id}/details`} state={product}><span className="capitalize">{product?.name}</span></Link>
                        </div>
                    </li>
                    ))}
                </ul>
            </div>
        </div>
    </section>
  )
}
